module.exports = __webpack_public_path__ + "img/mockup-areca.ee048ef.jpg";